import { Line, Bar } from "react-chartjs-2";
 import exportToHTML from "./exportToHTML";
import { Button } from "react-bootstrap";
    function colorsForLabels(labels, chartColors, fallback = "#ddddddff") {
    return labels.map(l => chartColors[l] ?? fallback);
}
function applySubjectColors(chart, chartColors) {
const colors = colorsForLabels(chart.labels, chartColors);

return {
    ...chart,
    datasets: chart.datasets.map(ds => ({
    ...ds,
    backgroundColor: colors,
    borderColor: colors,
    borderWidth: 1,
    })),
};
}
export function ClusterDashboard({ id, cluster, chartColors }) {
  const { stats, charts, connectedness } = cluster;
console.log(cluster);
  // Apply colors per subject
  charts.termGpaLine = applySubjectColors(
    charts.termGpaLine,
    chartColors
  );
  const subjectCourseCountBar = applySubjectColors(
    charts.subjectCourseCountBar,
    chartColors
  );

  const subjectQualityPointsBar = applySubjectColors(
    charts.subjectQualityPointsBar,
    chartColors
  );

  const subjectGpaBar = applySubjectColors(
    charts.subjectGpaBar,
    chartColors
  );

  const subjectGradeDiffBar = applySubjectColors(
    charts.subjectGradeDiffBar,
    chartColors
  );

  return (
    <div id={`cluster-dashboard-${id}_content`}>
      <Button
        variant="secondary"
        size="sm"
        onClick={() => exportToHTML(`cluster-dashboard-${id}`)}
      >
        Export Dashboard
      </Button>

      <h2>Cluster {id} Dashboard</h2>

      <div>
        <div>Total Students: {stats.totalStudents}</div>
        <div>Weighted GPA: {stats.gpaWeighted?.toFixed?.(2)}</div>
        <div>Total Units: {stats.totalUnits}</div>
        <div>Total Quality Points: {stats.totalQualityPoints?.toFixed?.(2)}</div>
        <div>Median Student-Term GPA: {stats.termGpaMedian?.toFixed?.(2)}</div>
        <div>Connection Density: {connectedness?.density?.toFixed?.(2)}</div>
        <div>Average Edge Weight: {connectedness?.avgEdgeWeight?.toFixed?.(2)}</div>
        <div>Cohesion: {connectedness?.cohesion?.toFixed?.(2)}</div>
      </div>

      <Line data={charts.termGpaLine} />

      <Bar data={subjectCourseCountBar} />
      <Bar data={subjectQualityPointsBar} />
      <Bar data={subjectGpaBar} />
      <Bar data={subjectGradeDiffBar} />
    </div>
  );
}